const routes = [
    {
        name: 'meuPlanoEmissor',
        path: '/emissor/planos/meu_plano',
        component: () => import('../views/MeuPlano'),
    },
]

export default routes